import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable, ViewChild } from "@angular/core";
import {
  ComponentItem,
  DataService,
  DynamicComponentLoaderService,
} from "fg-library";
import { from, Observable, switchMap, tap } from "rxjs";
import { of } from "rxjs";
import { LayoutService } from "./fg-client-module/shared/components/main-nav/layoutservice";
import {
  getAnalyticalQueryService,
  getQueryServiceApi,
  getQueryServiceV2,
} from "./mockService/mocker";
import { analyticalMock } from "./mockService/mockDataService";

@Injectable({
  providedIn: "root",
})
export class ClientDynamicComponentLoaderService extends DynamicComponentLoaderService {
  static clientComponentMapping = {
    // fgselect : TestComponentComponent,
  };

  getComponent(component: any, data: any, templateConfig: any): ComponentItem {
    var foundComp: ComponentItem;

    if (
      ClientDynamicComponentLoaderService.clientComponentMapping[component.type]
    ) {
      foundComp = new ComponentItem(
        ClientDynamicComponentLoaderService.clientComponentMapping[
          component.type
        ],
        { component: component, data: data, templateConfig: templateConfig },
        { type: "fginput" }
      );
    } else {
      switch (component.type) {
        case component.type:
          if (component.type == "fgvalue") {
            if (component.isHtml) {
              foundComp = new ComponentItem(
                DynamicComponentLoaderService.componentMapping["fgRichField"],
                {
                  component: component,
                  data: data,
                  templateConfig: templateConfig,
                },
                { type: "fgRichField" }
              );
            } else {
              foundComp =
                foundComp =
                foundComp =
                  new ComponentItem(
                    DynamicComponentLoaderService.componentMapping[
                      component.type
                    ],
                    {
                      component: component,
                      data: data,
                      templateConfig: templateConfig,
                    },
                    { type: "fginput" }
                  );
            }
          } else if (component.type != "fgvalue") {
            foundComp = new ComponentItem(
              DynamicComponentLoaderService.componentMapping[component.type],
              {
                component: component,
                data: data,
                templateConfig: templateConfig,
              },
              { type: "fginput" }
            );
          }
          break;
        default:
         // //console.log("No such component exists!");
          break;
      }
    }

    return foundComp;
  }
}

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  constructor(
    private layoutService: LayoutService,
    private dataService: DataService
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const body = req.body;
    const isMocDataEnabled = this.layoutService.getCurrentMocData();
    let queryServiceV2 = false;
    let callAnalyticalMock = false;
    let queryServiceApi = false;
    if (req.url.endsWith("queryServiceV2")) queryServiceV2 = true;
    if (req.url.endsWith("queryServiceApi")) queryServiceApi = true;
    if (req.url.endsWith("analyticalQueryService")) callAnalyticalMock = true;

    if (isMocDataEnabled && queryServiceV2) {
      return from(getQueryServiceV2(this.dataService, req)).pipe(
        switchMap((mockResponse: any) =>
          of(new HttpResponse({ status: 200, body: mockResponse }))
        )
      );
    }
    if (isMocDataEnabled && queryServiceApi) {
      return from(getQueryServiceApi(this.dataService, req)).pipe(
        switchMap((mockResponse: any) =>
          of(new HttpResponse({ status: 200, body: mockResponse }))
        )
      );
    }

if (isMocDataEnabled && callAnalyticalMock) {
  return from(getAnalyticalQueryService(this.dataService, req.body)).pipe(
    tap(mockBody => {
    //  //console.log('Mock Body from getAnalyticalQueryService:', mockBody);
      // You can do additional debugging or transformation here
    }),
    switchMap(mockBody =>
      of(new HttpResponse({ status: 200, body: mockBody }))
    )
  );
}

    return next.handle(req); // continue with real HTTP call
  }

  private getSampleJson(): any {
    // your mock logic here
    return [
      {
        PARTNER: "ENT2024724371020",
        STATUS: 5,
        PARTNER_NAME: "Mahindra Finance",
        STATUS_NAME: "",
      },
      {
        PARTNER: "ENT2024720367512",
        STATUS: 12,
        PARTNER_NAME: "Kotak Bank",
        STATUS_NAME: "",
      },
      {
        PARTNER: "ENT2024725371568",
        STATUS: 2,
        PARTNER_NAME: "Fingress Platform",
        STATUS_NAME: "",
      },
      {
        PARTNER: "ENT2024724371018",
        STATUS: 2,
        PARTNER_NAME: "IDFC First Bank",
        STATUS_NAME: "",
      },
    ];
  }
}
